import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import {createIntl, createIntlCache} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/ja'

import enMessages from './messages/en.json'
import jaMessages from './messages/ja.json'

const allMessages: {[key: string]: {[key: string]: string}} = {
  en: enMessages,
  ja: jaMessages,
}

const cache = createIntlCache()

// Create intl instance for use outside of React components
const createIntlInstance = (locale: string) => {
  return createIntl({locale, messages: allMessages[locale]}, cache)
}


const I18nProvider: FC = ({children}) => {
  let locale = useLang() as 'en' | 'ja' | string
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

// Export intl instance with default language (will be updated by context)
export const intl = createIntlInstance('ja')

export {I18nProvider}
